import { Avatar } from 'types/avatar/avatarList.def';

const filterAvatarList = (filteredAvatars: Avatar[], pageNumber: number) =>
  filteredAvatars.length > 0
    ? filteredAvatars.filter(avatar => {
        const avatarnbr = avatar.name.split('_');
        return (
          parseInt(avatarnbr[0]) > 12 * pageNumber &&
          parseInt(avatarnbr[0]) <= 12 * (pageNumber + 1)
        );
      })
    : [];

const sortingAvatarList = (filteredAvatars: Avatar[]) =>
  filteredAvatars.sort((a, b) => {
    const avatara = a.name.split('_');
    const avatarb = b.name.split('_');
    if (parseInt(avatara[0]) < parseInt(avatarb[0])) {
      return -1;
    } else {
      return 1;
    }
  });

export const carouselAvatarPages = (
  avatars: Avatar[],
  page: number,
  displayBronze: boolean,
  displaySilver: boolean,
  displayGold: boolean,
  displayHalloween: boolean
) => {
  let filteredAvatars = [];
  let pageNumber = 0;
  if (page >= 0 && page < 3) {
    filteredAvatars = avatars.filter(avatar => !avatar.name.includes('_'));
    pageNumber = page;
  }

  if (displayBronze && page > 2 && page < 6) {
    filteredAvatars = avatars.filter(avatar => avatar.name.includes('_bronze'));
    pageNumber = page - 3;
  }

  if (displaySilver && page > 5 && page < 9) {
    filteredAvatars = avatars.filter(avatar => avatar.name.includes('_silver'));
    pageNumber = page - 6;
  }

  if (displayGold && page > 8 && page < 12) {
    filteredAvatars = avatars.filter(avatar => avatar.name.includes('_gold'));
    pageNumber = page - 9;
  }

  if (displayHalloween && page > 11 && page < 13) {
    filteredAvatars = avatars.filter(avatar =>
      avatar.name.includes('_halloween')
    );
    pageNumber = page - 12;
  }

  filteredAvatars = filterAvatarList(filteredAvatars, pageNumber);
  filteredAvatars = sortingAvatarList(filteredAvatars);
  return filteredAvatars;
};
